import React from "react";
import {
  Button,
  HStack,
  Show,
  Table,
  Tag,
  TagLabel,
  Tbody,
  Td,
  Tr,
} from "@chakra-ui/react";
import { Trans, useTranslation } from "react-i18next";
import PrimaryCard from "../common/cards/PrimaryCard";

/**
 * Renders the available services card
 * 
 * @returns The available services card
 */
const OrganisedServicesCard = () => {
  const { t } = useTranslation();

  return (
    <PrimaryCard title={t("beneficiaryServices.organisedServices.title")}>
      <Table size={"sm"}>
        <Tbody>
          <Tr>
            <Td maxWidth={"150px"}>
              <Tag>
                <TagLabel>
                  <Trans>beneficiaryServices.organisedServices.towing</Trans>
                </TagLabel>
              </Tag>
            </Td>
            <Show above={"lg"}>
              <Td maxWidth={"150px"}>
                <Tag>
                  <TagLabel>ss:mm:hh dd/mm/yyyy</TagLabel>
                </Tag>
              </Td>
            </Show>
            <Show above={"sm"}>
              <Td maxWidth={"75px"}>
                <Tag backgroundColor={"red"}>
                  <TagLabel>
                    <Trans>beneficiaryServices.organisedServices.status</Trans>
                  </TagLabel>
                </Tag>
              </Td>
            </Show>
            <Show above={"lg"}>
              <Td maxWidth={"100px"}>
                <Tag>
                  <TagLabel>
                    <Trans>beneficiaryServices.organisedServices.cost</Trans>
                  </TagLabel>
                </Tag>
              </Td>
            </Show>
            <Td>
              <HStack justifyContent={"flex-end"}>
                <Button isDisabled={true} variant={"primary"}>
                  <Trans>beneficiaryServices.organisedServices.supplier</Trans>
                </Button>
              </HStack>
            </Td>
          </Tr>
        </Tbody>
      </Table>
    </PrimaryCard>
  );
};

export default React.memo(OrganisedServicesCard);
